export default __webpack_public_path__ + "static/media/tech-consulting.ab00299d.png";